import '../App.css';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useClickAnimation } from '../animations/useClickAnimation';
import blue_logo from '../images/pics/WH-logo-blue-dt.png'
import { redirectToExternalUrl } from './Contact';
import { URL_LINKDIN, URL_EMAIL, URL_GITHUB } from '../config.js';
import { TitleCards } from '../TitleCards';


export default function Header() {

    const { profile, project, contact } = useContext(TitleCards);

    const degreeToRadian = (degrees) => {
        return degrees * (Math.PI / 180);
    }

    const hexLength = 100;

    const largeHexStartX = GetDimensions().width * 1.02;
    const largeHexStartY = (GetDimensions().height * -1) / 2;

    const hexShape = (startX, startY, enlarge) => {
        return `${startX},${startY} 
                ${Math.sin(degreeToRadian(60)) * (hexLength * enlarge) + startX},${Math.cos(degreeToRadian(60)) * (hexLength * enlarge) + startY}
                ${Math.sin(degreeToRadian(60)) * (hexLength * enlarge) + startX},${(Math.cos(degreeToRadian(60)) * (hexLength * enlarge) + startY) + hexLength * enlarge}
                ${startX},${startY + (hexLength * enlarge * 2)}
                ${startX - Math.sin(degreeToRadian(60)) * (hexLength * enlarge)},${(Math.cos(degreeToRadian(60)) * (hexLength * enlarge) + startY) + hexLength * enlarge}
                ${startX - Math.sin(degreeToRadian(60)) * (hexLength * enlarge)},${Math.cos(degreeToRadian(60)) * (hexLength * enlarge) + startY}`
    }

    const [headerVisible, setHeaderVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const scroll = window.scrollY;
            setHeaderVisible(scroll > 345);
        }

        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    useEffect(() => {
        const showScroll = () => {
            const scroll = window.scrollY;
            console.log("Scroll Position: " + scroll);
            console.log("Positions: ");
            console.log(profile.current);
            console.log(project);
            console.log(contact);
        }

        window.addEventListener('click', showScroll);
        return () => window.removeEventListener('click', showScroll);
    }, [profile, project, contact]);

    const ani = useRef();

    useClickAnimation(ani, {
        color: '#0059ffff',
        duration: 700,
        size: 30,
        effectName: 'ripple'
    });

    return (
        <div style={{ position: 'relative' }}>
            <div>
                <DynamicHeader 
                visible={headerVisible} 
                menu={GetDimensions().width < 600}
                profile={profile}
                project={project}
                contact={contact}
                />

                <div className='header-block' ref={ani}>
                    <svg
                    width="100%"
                    height="100%"
                    viewBox={`0 0 ${GetDimensions().width} ${GetDimensions().height}`}
                    xmlns="http://www.w3.org/2000/svg"
                    className='header-svg'>
                        <polygon 
                        className='large-hex'
                        points={hexShape(largeHexStartX, largeHexStartY, 5)}
                        style={{ fill: 'none', stroke: 'white', strokeWidth: '10' }}/>
                        <polygon
                        className='med-hex'
                        points={hexShape(GetDimensions().width * 0.96, -GetDimensions().height / 9.2, 3)}
                        style={{ fill: 'none', stroke: '#4BC6FF', strokeWidth: '10' }}
                        />

                    </svg>
                    <div  className='static-header'>
                        <div className='logo-and-links'>
                            <img src={blue_logo} alt='Logo' className='logo'/>
                            {GetDimensions().width > 600 ? <div className='header-page-links'>
                                <p onClick={() => scrollToSection('profile', profile)}>About Me</p>
                                <p onClick={() => scrollToSection('project', project)}>Portfolio</p>
                                <p onClick={() => scrollToSection('contact', contact)} >Contact</p>
                            </div> 
                            :
                            <HamburgerMenu 
                            profile={profile}
                            project={project}
                            contact={contact}
                            />
                            }
                        </div>
                    </div>
                    <div className='header-contents'>
                        <div className='header-greeting'>
                            <div className='greeting'>
                                <span style={{ color: '#98d3ffff' }}>Hello, I am</span>
                            </div>
                            <div className='name'>
                                <span><span style={{ color: '#4a93cc' }}>W</span>ill</span> <div className='last-name'><span style={{ color: '#4a93cc' }}>H</span>arvey</div>
                            </div>
                        </div>
                        <div className='quick-contact'>
                            <p onClick={() => {redirectToExternalUrl(URL_LINKDIN)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-linkedin-icon lucide-linkedin"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg>
                            </p>
                            <p onClick={() => {redirectToExternalUrl(URL_GITHUB)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-github-icon lucide-github"><path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/><path d="M9 18c-4.51 2-5-2-7-2"/></svg>                                
                            </p>
                            <p onClick={() => {redirectToExternalUrl(URL_EMAIL)}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail-icon lucide-mail"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/><rect x="2" y="4" width="20" height="16" rx="2"/></svg>    
                            </p>
                        </div>
                    </div>
                </div> 
            </div>          
        </div>
    )
}

export function DynamicHeader({ visible, menu, profile, project, contact }) {

    return (
        <div>
        {visible && 
            <header className='header'>
                <div 
                className='fixed-back-btn'
                onClick={() => window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })}
                >^</div>
                <div className='logo-and-links'>
                    <Link to={'/'} style={{ textDecoration: 'none'}}>
                        <img
                        src={blue_logo}
                        alt='Logo'
                        onClick={() => window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })}
                        style={{height: '40px', width: '90px', marginTop: '1.9%', marginLeft: '1%', cursor: 'pointer' }}/>
                    </Link>
                    {menu ? 
                    <HamburgerMenu
                    profile={profile}
                    project={project}
                    contact={contact}
                    />
                    :
                    <div className='hidden-header-page-links'>
                        <Link to={'/'} style={{ textDecoration: 'none'}}><p onClick={() => scrollToSection('profile', profile)}>About Me</p></Link>
                        <Link to={'/'} style={{ textDecoration: 'none'}}><p onClick={() => scrollToSection('project', project)}>Portfolio</p></Link>
                        <Link to={'/'} style={{ textDecoration: 'none'}}><p onClick={() => scrollToSection('contact', contact)}>Contact</p></Link>
                    </div>
                    }
                    
                </div>
            </header>
        }
        </div>
    )
}

function HamburgerMenu({ profile, project, contact }) {

    const [openMenu, setOpenMenu] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setOpenMenu(false);
        }

        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <div onClick={() => setOpenMenu(!openMenu)} className='hamburger-menu'>
            <svg 
            width={60} height={50}>
                <path
                d='M10 10 L50 10 M10 25 L50 25 M10 40 L50 40'
                stroke='white'
                strokeWidth='5px'
                />
            </svg>
            {openMenu && 
            <div className='menu-container'>
                <div onClick={() => scrollToSection('profile', profile)}>About Me</div>
                <div onClick={() => scrollToSection('project', project)}>Project</div>
                <div onClick={() => scrollToSection('contact', contact)}>Contact</div>
            </div>
            }
        </div>
    )
}

export const GetDimensions = () => {

    const [dimensions, setDimensions] = useState({
        height: window.innerHeight, 
        width: window.innerWidth
    });

    useEffect(() => {
        const handleResize = () => {
            setDimensions(prevDimensions => ({
                ...prevDimensions,
                height : window.innerHeight,
                width : window.innerWidth
            }))
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize)
    }, []);

    return dimensions;
}

export const scrollToSection = (section, title) => {
    let titleCard = null;
    let top = 0;

    // Safe-guard: title or title.current may be null when we're on a different route
    if (title && title.current) {
        titleCard = title.current.getBoundingClientRect();
    }

    // Special-case: some pages request a top-of-page scroll using 'new_page'
    if (section === 'new_page') {
        window.scrollTo({ top: 0, behavior: 'instant' });
        return;
    }

    // If we have a valid title ref, scroll to it.
    if (titleCard) {
        top = titleCard.top + window.scrollY - 85;
        window.scrollTo({
            top: top,
            behavior: "smooth",
            block: "start"
        });
        return;
    }

    // Fallback: try to find an element on the page matching common section identifiers
    const fallbackEl = document.getElementById(section) || document.querySelector(`.${section}-section`) || document.querySelector(`[data-section="${section}"]`);
    if (fallbackEl) {
        const rect = fallbackEl.getBoundingClientRect();
        top = rect.top + window.scrollY - 85;
        window.scrollTo({ top, behavior: 'smooth', block: 'start' });
        return;
    }


    // Only attempt cross-route navigation for actual home sections.
    const homeSections = ['profile', 'project', 'contact'];
    if (homeSections.includes(section)) {
        try {
            sessionStorage.setItem('scrollToSection', section);
        } catch (e) {
            // ignore storage failures
        }

        if (window.location.pathname !== '/') {
            window.location.href = '/';
            return;
        }
    }

    // Last resort: scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
}
